import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
import { LanguageConstants } from '../constants/LanguageConstants';
const emojiFreeRegex = /^(?!.*[.\s]$).*/;



const profileValidation: any = yup.object().shape({
    name: yup.string().required(LanguageConstants?.PLEASE_ENTER_NAME)
        .min(3, LanguageConstants?.NAME_MIN)
        .max(25, LanguageConstants?.NAME_MAX)
        .matches(/^(?!.*\s{2,}).*$/, "Name cannot contain consecutive spaces")
        .matches(emojiFreeRegex, (LanguageConstants?.Emojis)),

    email: yup.string().required(LanguageConstants?.PLEASE_ENTER_Email)
        .email(LanguageConstants.EMAIL_ADDRESS)
        .matches(VALIDATION_MESSAGE.EMAIL_REGREX, LanguageConstants.EMAIL_ADDRESS)
        .max(150, LanguageConstants?.EMAIL_MAX)
        .trim(),
       phone_number: yup
  .string()
  .nullable()
  .notRequired()
  .when('$hasPhone', {
    is: true,
    then: schema =>
      schema
        .min(7, LanguageConstants.PHONE_NUMBER_VALID)
        .max(15, LanguageConstants.PHONE_MAX_CHAR)
        .matches(/^[0-9]*$/, LanguageConstants.VALID_PHONE_NUMBER)
        .test('no-zero', LanguageConstants.VALID_PHONE, v => !/^0+$/.test(v || '')),
  }),
        phone_country_code: yup.string().nullable().notRequired(),

   

});

export default profileValidation;

